// Тело юридического документа: заголовок, версия, лид и разделы.
//
// HEAL-69: вынесено из pages/LegalPage.tsx, потому что тот же текст показывается в двух
// местах — на экране /legal/* и в листе, который открывается с регистрации. Вторая копия
// разметки означала бы, что однажды экран и лист покажут разные редакции.

import { FileText } from 'lucide-react';
import { LEGAL_EFFECTIVE_DATE, LEGAL_VERSION_LABEL, type LegalDoc } from '@/content/legal';

export function LegalDocBody({ doc }: { doc: LegalDoc }) {
  return (
    <>
      <div className="mb-5">
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
          <FileText className="h-6 w-6" />
        </div>
        <h1 className="mb-1 text-[24px] font-bold leading-tight">{doc.title}</h1>
        {/* HEAL-3, пункт 4 тикета: версия документа видна пользователю. */}
        <p className="mb-2 text-[11px] text-muted-foreground">
          Версия {LEGAL_VERSION_LABEL} · вступает в силу {LEGAL_EFFECTIVE_DATE}
        </p>
        <p className="text-sm leading-relaxed text-muted-foreground">{doc.lead}</p>
      </div>

      <div className="space-y-4">
        {doc.sections.map((section) => (
          <section key={section.title} className="rounded-lg border border-border bg-card p-4">
            <h2 className="mb-2 text-sm font-semibold">{section.title}</h2>
            <div className="space-y-2">
              {section.blocks.map((block, i) =>
                block.kind === 'text' ? (
                  <p key={i} className="text-[12px] leading-relaxed text-muted-foreground">
                    {block.text}
                  </p>
                ) : (
                  <ul key={i} className="space-y-1 pl-4">
                    {block.items.map((item) => (
                      <li
                        key={item}
                        className="list-disc text-[12px] leading-relaxed text-muted-foreground marker:text-gray-400"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                ),
              )}
            </div>
          </section>
        ))}
      </div>
    </>
  );
}
